export const translate = (intl: Record<string, string>) => (key: string) => intl[key] ?? key;